/** Approvals API. Kalitlar ["approval", ...] -- real-time "approval" hodisasi hammasini yangilaydi. */
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, type Paginated, type RequestOptions } from "@/lib/api";
import type { Approval, ApprovalCounts } from "./types";

export const approvalKeys = {
  all: ["approval"] as const,
  list: (q: RequestOptions["query"]) => ["approval", "list", q] as const,
  counts: ["approval", "counts"] as const,
};

export function useApprovals(query: RequestOptions["query"], enabled = true) {
  return useQuery({
    queryKey: approvalKeys.list(query),
    queryFn: () => api.get<Paginated<Approval>>("/api/approvals/", { query }),
    placeholderData: keepPreviousData,
    enabled,
  });
}

export function useApprovalCounts() {
  return useQuery({
    queryKey: approvalKeys.counts,
    queryFn: () => api.get<ApprovalCounts>("/api/approvals/counts/"),
  });
}

export interface DecisionInput {
  id: number;
  action: "approve" | "reject";
  reason?: string;
  note?: string;
  return_to?: string;
  /** Hire tasdig'ida carrier to'lovi summasi (USD) */
  fee_amount?: string;
  version: number;
}

export function useDecideApproval() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, action, ...body }: DecisionInput) => api.post<Approval>(`/api/approvals/${id}/${action}/`, body),
    onSettled: () => {
      // Qaror driver statusiga, menyu belgilariga va bildirishnomalarga ta'sir qiladi
      qc.invalidateQueries({ queryKey: approvalKeys.all });
      qc.invalidateQueries({ queryKey: ["driver"] });
      qc.invalidateQueries({ queryKey: ["counts"] });
      qc.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}
